"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ServiceNow AI Toolkit
 * ServiceNow AI Toolkit API
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AccountApi - axios parameter creator
 * @export
 */
const AccountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get apps in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountAppGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/app`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create app in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppPost: (accountId_1, human_1, appPost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, appPost_1, ...args_1], void 0, function* (accountId, human, appPost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountAppPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/app`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get data in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountDataGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/data`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create data in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {DataPost} [dataPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataPost: (accountId_1, human_1, dataPost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, dataPost_1, ...args_1], void 0, function* (accountId, human, dataPost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountDataPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/data`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dataPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get accounts in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/account`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGetById: (accountId_1, human_1, ...args_1) => __awaiter(this, [accountId_1, human_1, ...args_1], void 0, function* (accountId, human, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountGetById', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountHeadById: (accountId_1, human_1, ...args_1) => __awaiter(this, [accountId_1, human_1, ...args_1], void 0, function* (accountId, human, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountHeadById', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job occupation statistics for an account
         * @param {string} accountId The ID or fullname of the account
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobOccupancyGet: (accountId_1, type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1) => __awaiter(this, [accountId_1, type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1], void 0, function* (accountId, type, from, to, noNull, limit, offset, order, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobOccupancyGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job_occupancy`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (noNull !== undefined) {
                localVarQueryParameter['no_null'] = noNull;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create job in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost: (accountId_1, human_1, jobSpec_1, ...args_1) => __awaiter(this, [accountId_1, human_1, jobSpec_1, ...args_1], void 0, function* (accountId, human, jobSpec, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(jobSpec, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobRunGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job_run`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create account in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPost: (accountId_1, human_1, accountPost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, accountPost_1, ...args_1], void 0, function* (accountId, human, accountPost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/account`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPutById: (accountId_1, human_1, accountPost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, accountPost_1, ...args_1], void 0, function* (accountId, human, accountPost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountPutById', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all jobs in the account which are replica jobs
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountReplicaJobsGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountReplicaJobsGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/replica_jobs`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get policies in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountRoleGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/role`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create role in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost: (accountId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, rolePost_1, ...args_1], void 0, function* (accountId, human, rolePost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountRolePost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/role`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get services in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServiceGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountServiceGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/service`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create service in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {ServicePost} [servicePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServicePost: (accountId_1, human_1, servicePost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, servicePost_1, ...args_1], void 0, function* (accountId, human, servicePost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountServicePost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/service`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(servicePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get accounts in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAccountGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get accounts in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationAccountGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/account`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create account in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountPost: (organizationId_1, human_1, accountPost_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, accountPost_1, ...args_1], void 0, function* (organizationId, human, accountPost, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationAccountPost', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/account`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create account in your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAccountPost: (human_1, accountPost_1, ...args_1) => __awaiter(this, [human_1, accountPost_1, ...args_1], void 0, function* (human, accountPost, options = {}) {
            const localVarPath = `/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get accounts in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAccountGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AccountApiAxiosParamCreator = AccountApiAxiosParamCreator;
/**
 * AccountApi - functional programming interface
 * @export
 */
const AccountApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AccountApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get apps in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountAppGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountAppGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create app in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppPost(accountId, human, appPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountAppPost(accountId, human, appPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountAppPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get data in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountDataGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountDataGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create data in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {DataPost} [dataPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataPost(accountId, human, dataPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountDataPost(accountId, human, dataPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get accounts in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGetById(accountId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountGetById(accountId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountHeadById(accountId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountHeadById(accountId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job occupation statistics for an account
         * @param {string} accountId The ID or fullname of the account
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobOccupancyGet(accountId, type, from, to, noNull, limit, offset, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobOccupancyGet(accountId, type, from, to, noNull, limit, offset, order, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountJobOccupancyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create job in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost(accountId, human, jobSpec, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobPost(accountId, human, jobSpec, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountJobPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobRunGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create account in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPost(accountId, human, accountPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountPost(accountId, human, accountPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPutById(accountId, human, accountPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountPutById(accountId, human, accountPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all jobs in the account which are replica jobs
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountReplicaJobsGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountReplicaJobsGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountReplicaJobsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get policies in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountRoleGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create role in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost(accountId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountRolePost(accountId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get services in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServiceGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountServiceGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountServiceGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create service in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {ServicePost} [servicePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServicePost(accountId, human, servicePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountServicePost(accountId, human, servicePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1AccountServicePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get accounts in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAccountGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterAccountGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1ClusterAccountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get accounts in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountGet(organizationId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationAccountGet(organizationId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1OrganizationAccountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create account in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountPost(organizationId, human, accountPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationAccountPost(organizationId, human, accountPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1OrganizationAccountPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create account in your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAccountPost(human, accountPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShorcutAccountPost(human, accountPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1ShorcutAccountPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get accounts in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAccountGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutAccountGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.v1ShortcutAccountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AccountApiFp = AccountApiFp;
/**
 * AccountApi - factory interface
 * @export
 */
const AccountApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AccountApiFp)(configuration);
    return {
        /**
         *
         * @summary Get apps in the account
         * @param {AccountApiV1AccountAppGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppGet(requestParameters, options) {
            return localVarFp.v1AccountAppGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create app in the account
         * @param {AccountApiV1AccountAppPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppPost(requestParameters, options) {
            return localVarFp.v1AccountAppPost(requestParameters.accountId, requestParameters.human, requestParameters.appPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get data in the account
         * @param {AccountApiV1AccountDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataGet(requestParameters, options) {
            return localVarFp.v1AccountDataGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create data in the account
         * @param {AccountApiV1AccountDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataPost(requestParameters, options) {
            return localVarFp.v1AccountDataPost(requestParameters.accountId, requestParameters.human, requestParameters.dataPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounts in the account
         * @param {AccountApiV1AccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGet(requestParameters, options) {
            return localVarFp.v1AccountGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get account
         * @param {AccountApiV1AccountGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGetById(requestParameters, options) {
            return localVarFp.v1AccountGetById(requestParameters.accountId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the account
         * @param {AccountApiV1AccountHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountHeadById(requestParameters, options) {
            return localVarFp.v1AccountHeadById(requestParameters.accountId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in the account
         * @param {AccountApiV1AccountJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet(requestParameters, options) {
            return localVarFp.v1AccountJobGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job occupation statistics for an account
         * @param {AccountApiV1AccountJobOccupancyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobOccupancyGet(requestParameters, options) {
            return localVarFp.v1AccountJobOccupancyGet(requestParameters.accountId, requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create job in the account
         * @param {AccountApiV1AccountJobPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost(requestParameters, options) {
            return localVarFp.v1AccountJobPost(requestParameters.accountId, requestParameters.human, requestParameters.jobSpec, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {AccountApiV1AccountJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet(requestParameters, options) {
            return localVarFp.v1AccountJobRunGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create account in the account
         * @param {AccountApiV1AccountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPost(requestParameters, options) {
            return localVarFp.v1AccountPost(requestParameters.accountId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update account
         * @param {AccountApiV1AccountPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPutById(requestParameters, options) {
            return localVarFp.v1AccountPutById(requestParameters.accountId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all jobs in the account which are replica jobs
         * @param {AccountApiV1AccountReplicaJobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountReplicaJobsGet(requestParameters, options) {
            return localVarFp.v1AccountReplicaJobsGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get policies in the account
         * @param {AccountApiV1AccountRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet(requestParameters, options) {
            return localVarFp.v1AccountRoleGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create role in the account
         * @param {AccountApiV1AccountRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost(requestParameters, options) {
            return localVarFp.v1AccountRolePost(requestParameters.accountId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get services in the account
         * @param {AccountApiV1AccountServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServiceGet(requestParameters, options) {
            return localVarFp.v1AccountServiceGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create service in the account
         * @param {AccountApiV1AccountServicePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServicePost(requestParameters, options) {
            return localVarFp.v1AccountServicePost(requestParameters.accountId, requestParameters.human, requestParameters.servicePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounts in the cluster
         * @param {AccountApiV1ClusterAccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAccountGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterAccountGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounts in the organization
         * @param {AccountApiV1OrganizationAccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountGet(requestParameters, options) {
            return localVarFp.v1OrganizationAccountGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create account in the organization
         * @param {AccountApiV1OrganizationAccountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountPost(requestParameters, options) {
            return localVarFp.v1OrganizationAccountPost(requestParameters.organizationId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create account in your account
         * @param {AccountApiV1ShorcutAccountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAccountPost(requestParameters = {}, options) {
            return localVarFp.v1ShorcutAccountPost(requestParameters.human, requestParameters.accountPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounts in your organization
         * @param {AccountApiV1ShortcutAccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAccountGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutAccountGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AccountApiFactory = AccountApiFactory;
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
class AccountApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get apps in the account
     * @param {AccountApiV1AccountAppGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountAppGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountAppGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create app in the account
     * @param {AccountApiV1AccountAppPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountAppPost(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountAppPost(requestParameters.accountId, requestParameters.human, requestParameters.appPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get data in the account
     * @param {AccountApiV1AccountDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountDataGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountDataGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create data in the account
     * @param {AccountApiV1AccountDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountDataPost(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountDataPost(requestParameters.accountId, requestParameters.human, requestParameters.dataPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounts in the account
     * @param {AccountApiV1AccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get account
     * @param {AccountApiV1AccountGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountGetById(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountGetById(requestParameters.accountId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the account
     * @param {AccountApiV1AccountHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountHeadById(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountHeadById(requestParameters.accountId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in the account
     * @param {AccountApiV1AccountJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountJobGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountJobGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job occupation statistics for an account
     * @param {AccountApiV1AccountJobOccupancyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountJobOccupancyGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountJobOccupancyGet(requestParameters.accountId, requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create job in the account
     * @param {AccountApiV1AccountJobPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountJobPost(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountJobPost(requestParameters.accountId, requestParameters.human, requestParameters.jobSpec, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs in the account
     * @param {AccountApiV1AccountJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountJobRunGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountJobRunGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create account in the account
     * @param {AccountApiV1AccountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountPost(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountPost(requestParameters.accountId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update account
     * @param {AccountApiV1AccountPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountPutById(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountPutById(requestParameters.accountId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all jobs in the account which are replica jobs
     * @param {AccountApiV1AccountReplicaJobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountReplicaJobsGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountReplicaJobsGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get policies in the account
     * @param {AccountApiV1AccountRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountRoleGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountRoleGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create role in the account
     * @param {AccountApiV1AccountRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountRolePost(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountRolePost(requestParameters.accountId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get services in the account
     * @param {AccountApiV1AccountServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountServiceGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountServiceGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create service in the account
     * @param {AccountApiV1AccountServicePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1AccountServicePost(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1AccountServicePost(requestParameters.accountId, requestParameters.human, requestParameters.servicePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounts in the cluster
     * @param {AccountApiV1ClusterAccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1ClusterAccountGet(requestParameters = {}, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1ClusterAccountGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounts in the organization
     * @param {AccountApiV1OrganizationAccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1OrganizationAccountGet(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1OrganizationAccountGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create account in the organization
     * @param {AccountApiV1OrganizationAccountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1OrganizationAccountPost(requestParameters, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1OrganizationAccountPost(requestParameters.organizationId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create account in your account
     * @param {AccountApiV1ShorcutAccountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1ShorcutAccountPost(requestParameters = {}, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1ShorcutAccountPost(requestParameters.human, requestParameters.accountPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounts in your organization
     * @param {AccountApiV1ShortcutAccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    v1ShortcutAccountGet(requestParameters = {}, options) {
        return (0, exports.AccountApiFp)(this.configuration).v1ShortcutAccountGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountApi = AccountApi;
